import { CampaignType } from './types';

import { axiosInstance } from 'services/common/instance';

export const getCampaignsService = async (): Promise<CampaignType> => {
  const res = await axiosInstance.get('campaigns');
  return res.data.data;
};

export const placeholder = () => { };
